import React from "react";
import "../../../style/landing.css";
import { FaCircleArrowRight } from "react-icons/fa6";
import { BiSolidCustomize } from "react-icons/bi";
import { RiSendPlane2Fill } from "react-icons/ri";

const HowItWorks = () => {
  return (
    <section className="work-section">
      <header>
        <h2 className="lp-product-heading">How it work</h2>
        <h2 className="lp-heading">Effortless Newsletter Magic</h2>
      </header>

      <p className="lp-heading-desc">
        Learn how to effortlessly set up and maximize Newslettrai’s powerful
        features.
      </p>

      <div className="lp-container">
        <div className="lp-product-section">
          <article
            className="lp-product-card work-card"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <FaCircleArrowRight
              className="work-icon"
              style={{ color: "#00BFA6" }}
            />
            <h3>Sign Up</h3>
            <p className="lp-text">
              Unlock the power of AI-driven newsletters.
            </p>
          </article>

          <article
            className="lp-product-card work-card"
            data-aos="fade-right"
            data-aos-duration="750"
          >
            <BiSolidCustomize
              className="work-icon"
              style={{ color: "#0074D9" }}
            />
            <h3>Customize</h3>
            <p className="lp-text">
              Transform content into subscriber-perfect emails.
            </p>
          </article>

          <article
            className="lp-product-card work-card"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <RiSendPlane2Fill
              className="work-icon"
              style={{ color: "#FFC700" }}
            />
            <h3>Send & Shine</h3>
            <p className="lp-text">Deliver, engage, and watch results soar.</p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
